import React from 'react';
import {useNavigate} from "react-router";
import {useLocation} from "react-router-dom";
import {Grid, Stack, Typography} from "@mui/material";
import Divider from "@mui/material/Divider";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {fixStringToHtml} from "../../../../tools/helper";

const Details = () => {
    const {state} = useLocation();
    const ticket = state?.item;
    const navigate = useNavigate();


    return (
        <Grid container>
            {/*Content Header*/}
            <Grid container justifyContent={'space-between'} alignItems={'center'} sx={{width: '100%'}}
                  flexDirection={'row-reverse'}>
                <Grid onClick={() => navigate(-1)}
                      style={{cursor: 'pointer'}}
                >
                    <ArrowBackIcon style={{color: '#592EA9', width: '80px'}}/>
                </Grid>
                <Typography variant="h6" component="h2"
                            sx={{fontWeight: '600'}}>
                    تیکت ها
                </Typography>
                <div style={{visibility: 'hidden', width: '80px'}}/>
            </Grid>

            <Divider sx={{
                width: '100%',
                mb: 4,
                mt: 2,
                height: '2px',
                backgroundColor: 'rgb(89, 46, 169)',
                boxShadow: ' -2px 2px 6px -1px rgb(89, 46, 169)',
            }}/>

            <Grid item xs={12}>
                <Stack>
                    <Stack sx={{p: 3, borderRadius: "20px", boxShadow: '0px 10px 10px -6px rgb(0 0 0 / 7%)'}}
                           direction={'row'} gap={1} alignItems={'center'} justifyContent={'space-between'}>
                        <Grid item xs={2}>
                            <Typography>
                                نام فرستنده
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography>
                                نام شرکت
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography>
                                شماره همراه
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography>
                                تاریخ
                            </Typography>
                        </Grid>
                    </Stack>
                    <Stack sx={{p: 3, mt: 2}} direction={'row'} gap={1} alignItems={'center'}
                           justifyContent={'space-between'}>
                        <Grid item xs={2}>
                            <Typography>
                                {fixStringToHtml(ticket?.fullname) ?? 'unknown'}
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography>
                                {fixStringToHtml(ticket?.company_name)}
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography>
                                {ticket?.mobile}
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography>
                                {ticket?.created_at}
                            </Typography>
                        </Grid>
                    </Stack>

                </Stack>

                <Divider sx={{
                    width: '100%',
                    mb: 4,
                    mt: 2,
                    height: '2px',
                    boxShadow: ' -2px 2px 6px -1px rgb(89, 46, 169)',
                }}/>

                <Typography mb={3}>
                    متن پیام:
                </Typography>
                <Typography sx={{
                    color: '#939393',
                    borderRadius: "10px",
                    boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
                    p: '30px 40px 70px 40px'
                }} dangerouslySetInnerHTML={{__html: fixStringToHtml(ticket?.body)}}/>
            </Grid>
        </Grid>
    );
};

export default Details;